import React from 'react';
import {cn} from '@chekinapp/ui';
import genericPhoto from 'assets/img/property-link-generic.webp';
import {useFirstScreenReady} from 'utils/firstScreen';
import styles from './propertyLinkPhoto.module.css';

let zoomStartedAt: number | undefined;

const useSharedZoomDelay = () =>
  React.useState(() => {
    const now = performance.now();
    zoomStartedAt ??= now;
    return `${zoomStartedAt - now}ms`;
  })[0];

type Props = {
  className?: string;
};

function PropertyLinkPhoto({className}: Props) {
  const zoomDelay = useSharedZoomDelay();
  useFirstScreenReady();

  return (
    <div
      className={cn(
        'absolute inset-0 isolate [background:var(--chekin-gradient-duotone)]',
        className,
      )}
    >
      <img
        src={genericPhoto}
        alt=""
        data-entrance="photo"
        style={{animationDelay: zoomDelay}}
        className={cn(
          'absolute inset-0 size-full object-cover opacity-[0.38] mix-blend-luminosity',
          styles.photo,
        )}
      />
      <div className="absolute inset-0 bg-[linear-gradient(180deg,transparent_35%,color-mix(in_srgb,var(--chekin-blue-950)_55%,transparent)_100%)]" />
    </div>
  );
}

export {PropertyLinkPhoto};
